import styles from './ErrorBoundary.module.scss';
import { emptyStateWarningGraphic } from '@workday/canvas-graphics-web';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import React from 'react';
import { Graphic, PrimaryButtonProps } from '@workday/canvas-kit-react';

export interface ErrorBoundaryPanelProps {
    title: string;
    description: string;
    returnButtonProps?: PrimaryButtonProps & { text: string; onClick: () => void };
}

export function ErrorBoundaryPanel({ title, description, returnButtonProps }: ErrorBoundaryPanelProps) {
    const { text, ...rest } = returnButtonProps || {};

    return (
        <div className={styles.errorBoundary}>
            <div className={styles.container}>
                <Graphic src={emptyStateWarningGraphic} />
                <h1 className={styles.heading}>{title}</h1>
                <p>{description}</p>
                {returnButtonProps && (
                    <PrimaryButton type='button' className={styles.button} {...rest}>
                        {text}
                    </PrimaryButton>
                )}
            </div>
        </div>
    );
}
